import { render } from "./showPreviewProduct.vue?vue&type=template&id=b8721a56"
import script from "./showPreviewProduct.vue?vue&type=script&lang=js"
export * from "./showPreviewProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__